import { hivemindConstants } from '@godaddy/hivemind-common'
import getClient from './get-client'
import HivemindClient from './hivemind-client'

export default HivemindClient
export { hivemindConstants, getClient }
